import { DataProvider, HttpError } from 'react-admin';

export interface UserRecord {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface UsersDataProvider extends DataProvider<'users'> {}

/* There are some "any" assertions in return data to satisfy the generic approach to using the React Admin dataProvider. Without these,
React Admin will try to warn us that a dataProvider method could be called with another resource method. When calling methods explicitly,
use type parameters for type safety:
dataProvider.getOne<UserRecord>('users', params) returns Promise<GetOneResult<UserRecord>>
*/
export const usersDataProvider: UsersDataProvider = {
  getOne: async () => {
    const uuid = sessionStorage.getItem('uuid');
    if (!uuid) {
      throw new HttpError('Users UUID not found in session', 401);
    }

    const name = sessionStorage.getItem('name') || '';
    const email = sessionStorage.getItem('email') || '';

    const spaceIndex = name.indexOf(' ');
    const firstName = spaceIndex === -1 ? name : name.slice(0, spaceIndex);
    const lastName = spaceIndex === -1 ? '' : name.slice(spaceIndex + 1);

    const user: UserRecord = {
      id: uuid,
      firstName: firstName || '—',
      lastName: lastName || '—',
      email: email || '—',
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return { data: user as any };
  },

  getList: async () => {
    throw new Error('getList not implemented for users resource');
  },

  getMany: async () => {
    throw new Error('getMany not implemented for users resource');
  },

  getManyReference: async () => {
    throw new Error('getManyReference not implemented for users resource');
  },

  create: async () => {
    throw new Error('create not implemented for users resource');
  },

  update: async () => {
    throw new Error('update not implemented for users resource');
  },

  updateMany: async () => {
    throw new Error('updateMany not implemented for users resource');
  },

  delete: async () => {
    throw new Error('delete not implemented for users resource');
  },

  deleteMany: async () => {
    throw new Error('deleteMany not implemented for users resource');
  },
};

export default usersDataProvider;
